enum Language {
  EnUs = 'en-US',
  UkUa = 'uk-UA',
}

export default Language;
